import type { ButtonT } from 'UI/Forms/Button/types';

export const BUTTON_SIZE: ButtonT['size'] = {
  initial: 'large',
  md: 'medium',
};
